import styled from "styled-components";

export const DashboardOperationsUserContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 20px;
  height: calc(100vh - 130px);
  overflow-y: auto;
  width: 100%;
`;

//PIECHART
export const ChartContainer = styled.div`
  background-color: var(--bkg-tertiary);
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
  color: var(--text-primary);
  display: flex:
  flex-direction: column;
  width: 100%;
  height: 100%;

`;

export const AddProjectComponent = styled.div`
  max-width: 100%;
  height: auto;
  padding: 20px;
  border-radius: 8px;
  background: var(--bkg-tertiary);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  gap: 20px;
  font-size: 18px;
  color: var(--text-primary);

  h6 {
    font-size: 18px;
    font-weight: 500;
  }
  hr {
    border: 1px solid var(--text-secondary);
    opacity: 0.4;
  }
  p {
    margin-top: 8px;
    color: var(--text-secondary);
    font-size: 14px;
    a {
      text-decoration: underline;
      color: var(--text-secondary);
    }
  }
`;
